export const handleSegmentTimeChanged = (playerContext, segment) => {
    let isFinished = false;
    const handleTimeGreaterThanOutpoint = (e) => {
        if (e.time > segment.outpoint && !isFinished) {
            isFinished = true;
            playerContext.player.seek(Math.max(segment.inpoint, segment.outpoint));
            playerContext.player.pause();
            playerContext?.player.addClassToNpoPlayerElement('bmpui-player-state-replay');
        }
    };
    const handleTimeLessThanInpoint = (e) => {
        if (e.time < segment.inpoint || (e.time > segment.outpoint && isFinished)) {
            isFinished = false;
            playerContext.player.seek(segment.inpoint);
        }
    };
    return (e) => {
        handleTimeGreaterThanOutpoint(e);
        handleTimeLessThanInpoint(e);
    };
};
